import { createContext, useState, useEffect, useContext } from "react";
import { getAllSessionNotifications, getLoggedInUser } from "../api";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// Create the UserContext
const UserContext = createContext();

// Custom hook to use the UserContext
export const useUserContext = () => useContext(UserContext);

// Provider component to wrap the app and provide the UserContext data
export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [notification, setNotification] = useState([]);
  const [unreadNotification, setUnreadNotification] = useState(0);
  const [isLoading, setisLoading] = useState(true);
  const [previousPage, setPreviousPage] = useState("");
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      setPreviousPage(location.pathname);
    };
  }, [location.pathname]);
  useEffect(() => {
    // Check if there's a token in the local storage when the app mounts
    const token = localStorage.getItem("token");
    if (token) {
      // Call the function to get user data from the token
      getUserFromToken(token);
      fetchNotifications()
    }

    if (!token) {
      setisLoading(false);
    }
  }, []);

  // Function to get user data from the token
  const getUserFromToken = async (token = localStorage.getItem("token")) => {
    setisLoading(true);
    const formData = new FormData();
    formData.append("token", token);

    try {
      const userFromToken = await getLoggedInUser(formData);
      setUser(userFromToken?.data?.data);
    } catch (error) {
      console.info("error", error);
    } finally {
      setisLoading(false);
    }
  };

  // Function to handle user logout
  const handleLogout = () => {
    // Remove the token from local storage
    localStorage.removeItem("token");
    localStorage.setItem("navigation",JSON.stringify("/"));

    // Clear the user data from the state
    setUser(null);
    toast.success("Logout Successfully.")
    navigate("/");
  };

  const fetchNotifications = async () => {
      try {
        const response = await getAllSessionNotifications();
        setNotification(response.data.data);
        setUnreadNotification(response.data.unreadCount);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };
  return (
    <UserContext.Provider
      value={{
        isLoading,
        user,
        getUserFromToken,
        handleLogout,
        previousPage,
        isOpen,
        setIsOpen,
        fetchNotifications,
        notification,unreadNotification
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
